export function generateCsv<T extends object>(data: [T, ...T[]]): string {
  const keys = Object.keys(data[0]) as (keyof T)[];

  let out = `${keys.join(",")}`;

  for (const row of data) {
    const values = keys.map(key => row[key]);
    out += `\n${values.map(v => `"${v}"`).join(",")}`;
  }

  return out;
}
